import { NavItem } from "src/components/layout/nav/nav-item";
import { Icon } from "src/components/layout/nav/icons/home";
import { UseSectionHook } from "./types";
import { useUser } from "src/contexts/user-context";
import { useSpaceContext } from "src/components/spaces";

export const useHomeSection: UseSectionHook = () => {
  const { isOnboarding } = useUser();

  return {
    title: "Home",
    isEnabled: !isOnboarding,
    links: [
      {
        href: "/home",
        label: "Home",
      },
    ],
  };
};

export const Home = () => {
  const { isEnabled } = useHomeSection();
  const { isInSpace, isPathAccessibleInSpace } = useSpaceContext();

  if (!isEnabled) {
    return null;
  }

  // Hide when in a space and the path is not accessible
  if (isInSpace && !isPathAccessibleInSpace("/home")) {
    return null;
  }

  return <NavItem href="/home" icon={Icon} label="Home" />;
};
